import { type FC } from 'react';

import InfoIcon from '@/assets/svg/ui-elements/info-circle-alt.svg';

import { StyledHelper, StyledIconWrapper } from './Helper.styled';
import type { HelperProps } from './types';

const Helper: FC<HelperProps> = ({
  label,
  state = 'default',
  iconStart = true,
  exiting = false,
  ...rest
}) => (
  <StyledHelper $state={state} $exiting={exiting} aria-hidden={exiting || undefined} {...rest}>
    {iconStart && (
      <StyledIconWrapper>
        <InfoIcon />
      </StyledIconWrapper>
    )}
    {label}
  </StyledHelper>
);

Helper.displayName = 'Helper';

export default Helper;
